import { createContext, useContext } from 'react';
import { thousands } from './format';

// Toneladas o miles de cajas equivalentes (kilos / kg por caja de la especie):
// lo elige el usuario en el panel y cambia todas las tablas y gráficos.
export type VolumeUnit = 'kg' | 'box';

export const VolumeUnitContext = createContext<{ unit: VolumeUnit; kgPerBox: number }>({
  unit: 'kg',
  kgPerBox: 5,
});

export const useVolumeUnit = () => {
  const { unit, kgPerBox } = useContext(VolumeUnitContext);
  // Kilos → toneladas, o cajas → miles de cajas: el número que se muestra.
  const toUnit = (kilos: number | null | undefined) =>
    (unit === 'box' ? (kilos ?? 0) / kgPerBox : kilos ?? 0) / 1000;
  return {
    unit,
    toUnit,
    // "569.502" (t) o "113.900" (miles de cajas).
    v: (kilos: number | null | undefined) => thousands(toUnit(kilos)),
    // Claves de traducción (namespace volume).
    label: unit === 'box' ? 'mil cajas' : 't',
    header: unit === 'box' ? 'MILES DE CAJAS' : 'TONELADAS',
  };
};
